module.exports = __webpack_public_path__ + "static/home-f792bce3bb59001775e662f1991c3a85.jpg";